import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import MainApp from './MainApp.jsx'
import { initConsoleOverride } from './shared/utils/consoleOverride'

// 앱 시작 전에 console 오버라이드 초기화
initConsoleOverride()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <MainApp />
  </StrictMode>,
)
